import React, { Component } from "react";
import { Line } from "react-chartjs-2";
import dimensions from "./MockData/dimensions.js";

const dataObject = {
  label: "My First dataset",
  fill: false,
  lineTension: 0.1,
  backgroundColor: "rgba(75,192,192,0.4)",
  borderColor: "rgba(75,192,192,1)",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0.0,
  borderJoinStyle: "miter",
  pointBorderColor: "rgba(75,192,192,1)",
  pointBackgroundColor: "#fff",
  pointBorderWidth: 1,
  pointHoverRadius: 5,
  pointHoverBackgroundColor: "rgba(75,192,192,1)",
  pointHoverBorderColor: "rgba(220,220,220,1)",
  pointHoverBorderWidth: 2,
  pointRadius: 1,
  pointHitRadius: 10,
  data: [65, 59, 80, 81, 56, 55, 40],
};

const arr = [];

dimensions.forEach((i) => {
  let dataModel = { ...dataObject };
  dataModel.data = [...i.data.series[0]];
  dataModel.label = i.title;
  dataModel.borderColor = i.color[0];
  arr.push(dataModel);
});

const data = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [...arr],
  /* [
    {
      label: 'My First dataset',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [65, 59, 80, 81, 56, 55, 40]
    }
  ]
  */
};

export default class LineDemo extends Component {
  render() {
    return (
      <div>
        <Line
          ref="chart"
          data={data}
          width={300}
          height={100}
          legend={{ position: "bottom" }}
        />
      </div>
    );
  }

  /*
  componentDidMount() {
    const { datasets } = this.refs.chart.chartInstance.data;
    //console.log(datasets[0].data);
  }
*/
}
